module.exports = __webpack_public_path__ + "client/img/confirm_layer_header.758e2656.png";